import { Stabilizer, Qubit } from '../../types/stabilizer';

interface Props {
  stabilizer: Stabilizer;
  qubits: Qubit[];
  position: { x: number; y: number };
}

export default function StabilizerInfoPanel({ stabilizer, qubits, position }: Props) {
  const memberQubits = qubits
    .filter((q) => stabilizer.qubitIds.includes(q.id))
    .sort((a, b) => a.index - b.index);

  return (
    <div
      className="absolute z-50 pointer-events-none bg-gray-900 text-white text-sm rounded-lg shadow-xl border border-gray-700 p-3 min-w-[220px]"
      style={{ left: position.x + 16, top: position.y - 8 }}
    >
      <div className="flex items-center gap-2 mb-2">
        <div
          className="w-3 h-3 rounded-sm border border-white/30"
          style={{ backgroundColor: stabilizer.color }}
        />
        <span className="font-bold">
          {stabilizer.name || `Stabilizer ${stabilizer.id.slice(-4)}`}
        </span>
      </div>

      <table className="w-full text-xs">
        <tbody>
          <tr>
            <td className="text-gray-400 pr-3 py-0.5">ID</td>
            <td className="font-mono">{stabilizer.id.slice(-8)}</td>
          </tr>
          <tr>
            <td className="text-gray-400 pr-3 py-0.5">Type</td>
            <td>
              <span
                className={`font-bold ${
                  stabilizer.type === 'X' ? 'text-purple-400' : 'text-blue-400'
                }`}
              >
                {stabilizer.type}-stabilizer
              </span>
            </td>
          </tr>
          <tr>
            <td className="text-gray-400 pr-3 py-0.5">Weight</td>
            <td>{memberQubits.length}</td>
          </tr>
          <tr>
            <td className="text-gray-400 pr-3 py-0.5">Qubits</td>
            <td className="font-mono">
              [{memberQubits.map((q) => q.index).join(', ')}]
            </td>
          </tr>
          <tr>
            <td className="text-gray-400 pr-3 py-0.5">Operator</td>
            <td className="font-mono">
              {memberQubits.map((q) => `${stabilizer.type}${q.index}`).join(' ')}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
